module.exports = __webpack_public_path__ + "img/national-emblem.2293f631.png";